import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EnumCodigosTwTcAcciones } from '../../_importacion/solicitudes/types/enum';
import { BuscadorAtestacionListComponent } from './atestaciones/buscador-atestacion-list.component';
import { BuscadorCpeListComponent } from './cpe/buscador-cpe-list.component';
import { BuscadorProductoExListComponent } from './productos/buscador-productoEx-list.component';
import { BuscadorSolicitudExListComponent } from './solicitudes/buscador-solicitudEx-list.component';
import { LoginGuard, ActionGuard } from '../../core/_infrastructure/classes/guards/main.guard';
import { CertificacionEditComponent } from '../cpe/certificacion/certificacion-edit.component';
import { CertificadosFsWrapperEditComponent } from './certificadosfs/buscador-certificadosfs-wrapper-edit/buscador-certificadosfs-wrapper-edit.component';
import { BuscadorCertificadosFsWrapperComponent } from './certificadosfs/buscador-certificadosfs-wrapper/buscador-certificadosfs-wrapper.component';

const buscadoresExRoutes: Routes = [
    //SOLICITUDES
    {
        path: 'exportacion/solicitudes',
        data: {
            breadcrumb: 'Solicitudes',
            menu0: 'EXPORTACIÓN', //,
            //menu1: 'Buscadores'
        },

        children: [
            {
                path: '',
                component: BuscadorSolicitudExListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.SOLICITUD_EXPORTACION,
                },
            },
        ],
    },
    //PRODUCTOS
    {
        path: 'exportacion/productos',
        data: {
            breadcrumb: 'Productos',
            menu0: 'EXPORTACIÓN', //,
            //menu1: 'Buscadores'
        },

        children: [
            {
                path: '',
                component: BuscadorProductoExListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.SOLICITUD_EXPORTACION,
                },
            },
        ],
    },

    //ATESTACIONES
    {
        path: 'exportacion/atestaciones',
        data: {
            breadcrumb: 'Atestaciones',
            menu0: 'EXPORTACIÓN', //,
            //menu1: 'Buscadores'
        },

        children: [
            {
                path: '',
                component: BuscadorAtestacionListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.SOLICITUD_ATESTACION,
                },
            },
        ],
    },

    //CERTIFICADOSFS
    {
        path: 'exportacion/certificadosfs',
        data: {
            breadcrumb: 'Certificados Fs',
            menu0: 'EXPORTACIÓN', //,
            //menu1: 'Buscadores'
        },

        children: [
            {
                path: '',
                component: BuscadorCertificadosFsWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.BUSCADOR_CFS,
                },
            },
            {
                path: 'detalleSolicitud/:idSolicitud',
                component: CertificadosFsWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar',
                    actionCode: EnumCodigosTwTcAcciones.BUSCADOR_CFS,
                },
            },
        ],
    },
    //CPE
    {
        path: 'exportacion/cpes',
        data: {
            breadcrumb: 'CPEs',
            menu0: 'EXPORTACIÓN', //,
            //menu1: 'Buscadores'
        },

        children: [
            {
                path: '',
                component: BuscadorCpeListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.SOLICITUD_CPE,
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(buscadoresExRoutes)],
    exports: [RouterModule],
})
export class BuscadoresExRoutingModule {}
